import React from 'react'
import { Button } from '@paintscout/ui'
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined'
import type { PainterAdditionalWork } from './types'
import type { usePainterAdditionalWorkStyles } from './usePainterAdditionalWorkStyles'

interface ApprovedAdditionalWorkActionsProps {
  item: PainterAdditionalWork
  onViewMedia?: (id: string) => void
  classes: ReturnType<typeof usePainterAdditionalWorkStyles>
}

export default function ApprovedAdditionalWorkActions({
  item,
  onViewMedia,
  classes
}: ApprovedAdditionalWorkActionsProps) {
  if (!onViewMedia || !item.hasMedia) return null
  return (
    <div className={classes.awViewMediaRow}>
      <Button
        className={classes.awViewMediaBtn}
        variant="dialog"
        icon={ImageOutlinedIcon}
        onClick={() => onViewMedia?.(item.id)}
      >
        View Media
      </Button>
    </div>
  )
}
